'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

var _defaultClasses = require('../../../../../constants/defaultClasses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _renderTotal = function _renderTotal(components, data, selectedCurrencyFormat) {
  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.ApproximateTotalValueLabel)) },
            (0, _priceString2.default)(selectedCurrencyFormat, data.totalPrice, data.currency)
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.ApproximateTotalTitleLabel)) },
            'Approximate total'
          )
        )
      )
    )
  );
};

function CarTotalFooter(props) {
  var option = props.option,
      components = props.components,
      selectedCurrencyFormat = props.selectedCurrencyFormat;


  return _react2.default.createElement(
    'table',
    { style: _defaultClasses.mainTableClass, 'data-component': 'CarHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.TotalContainer)) },
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.TotalContainer), { padding: '10px' }) },
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.DailyRateTitleLabel)) },
            'Daily Rate:'
          )
        ),
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.TotalContainer), { padding: '10px' }) },
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.DailyRateValueLabel)) },
            (0, _priceString2.default)(selectedCurrencyFormat, option.totalPriceItem.priceData.totalPrice, option.totalPriceItem.priceData.currency)
          )
        ),
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.TotalContainer), { padding: '10px' }) },
          _renderTotal(components, option.totalPriceItem.priceData, selectedCurrencyFormat)
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    selectedCurrencyFormat: state.rendering.shopOptions.currencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(CarTotalFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Passive/CarTotalFooter.jsx
// module id = 1505
// module chunks = 0